/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivXInvoiceControllerExportXmlParamsGen,
  MrfiktivXInvoiceControllerImportParamsGen,
  MrfiktivXInvoiceControllerImportPayloadGen,
  MrfiktivXInvoiceControllerValidateFilePayloadGen,
  MrfiktivXInvoiceControllerValidateParamsGen,
  MrfiktivXInvoiceDataViewModelGen,
  MrfiktivXInvoiceImportReportViewModelGen,
  MrfiktivXInvoiceValidationReportViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class XInvoice<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags x-invoice
   * @name XInvoiceControllerImport
   * @summary (X_INVOICE-CREATE) Import an X-Invoice (XRechnung XML or ZUGFeRD PDF) as inbound invoice
   * @request POST:/partner/{partnerId}/invoice/x-invoice
   * @secure
   * @response `201` `MrfiktivXInvoiceImportReportViewModelGen` The import report with the created invoice
   * @response `422` `void` The document was rejected by the external validator; the response body carries the report. Use force=true to import anyway.
   */
  xInvoiceControllerImport = (
    { partnerId, ...query }: MrfiktivXInvoiceControllerImportParamsGen,
    data: MrfiktivXInvoiceControllerImportPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivXInvoiceImportReportViewModelGen, void>({
      path: `/partner/${partnerId}/invoice/x-invoice`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags x-invoice
   * @name XInvoiceControllerValidateFile
   * @summary (X_INVOICE-READ) Validate an uploaded document (XRechnung XML or ZUGFeRD PDF) against the external validator
   * @request POST:/partner/{partnerId}/invoice/x-invoice/validation
   * @secure
   * @response `200` `MrfiktivXInvoiceValidationReportViewModelGen` The advisory validation report. Reports configured=false when no validator is set up and failed=true when it could not be reached.
   * @response `400` `void` No file was uploaded, or the PDF carries no embedded e-invoice XML
   */
  xInvoiceControllerValidateFile = (
    partnerId: string,
    data: MrfiktivXInvoiceControllerValidateFilePayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivXInvoiceValidationReportViewModelGen, void>({
      path: `/partner/${partnerId}/invoice/x-invoice/validation`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags x-invoice
   * @name XInvoiceControllerExportXml
   * @summary (X_INVOICE-READ) Export an invoice as X-Invoice (EN 16931 CII) XML
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}/x-invoice
   * @secure
   * @response `200` `void` The X-Invoice XML for the invoice
   */
  xInvoiceControllerExportXml = (
    { partnerId, invoiceId, ...query }: MrfiktivXInvoiceControllerExportXmlParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/x-invoice`,
      method: "GET",
      query: query,
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags x-invoice
   * @name XInvoiceControllerGetStored
   * @summary (X_INVOICE-READ) Get the stored e-invoice XML snapshot of an invoice
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}/x-invoice/stored
   * @secure
   * @response `200` `MrfiktivXInvoiceDataViewModelGen` The stored e-invoice XML snapshot
   * @response `404` `void` The invoice has no stored e-invoice XML snapshot
   */
  xInvoiceControllerGetStored = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivXInvoiceDataViewModelGen, void>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/x-invoice/stored`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags x-invoice
   * @name XInvoiceControllerValidate
   * @summary (X_INVOICE-READ) Validate the X-Invoice XML of an invoice against the external validator
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}/x-invoice/validation
   * @secure
   * @response `200` `MrfiktivXInvoiceValidationReportViewModelGen` The advisory validation report
   */
  xInvoiceControllerValidate = (
    { partnerId, invoiceId, ...query }: MrfiktivXInvoiceControllerValidateParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivXInvoiceValidationReportViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/x-invoice/validation`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
